import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { LayoutsDefault } from './Default';
import { LayoutsReveal } from './Reveal';
import {
  isMultiRedeemable,
  isVoucherV2,
  getHuggg,
  getVouchers
} from 'redux/modules/huggg';
import { isAuthed } from 'redux/modules/auth/status';

function Layout(props) {
  const menuItems = { left: [], right: [] };

  if (props.layout === 'reveal') {
    return <LayoutsReveal {...props} menuItems={menuItems} />;
  }

  return <LayoutsDefault {...props} menuItems={menuItems} />;
}

Layout.defaultProps = {
  backAction: null,
  showBackButton: true
};

Layout.propTypes = {
  layout: PropTypes.oneOf(['default', 'reveal']),
  backAction: PropTypes.func,
  showBackButton: PropTypes.bool,
  vouchers: PropTypes.array,
  huggg: PropTypes.object,
  isAuthed: PropTypes.bool,
  logout: PropTypes.func
};

function mapStateToProps(state) {
  return {
    huggg: getHuggg(state),
    isMultiRedeemable: isMultiRedeemable(state),
    isVoucherV2: isVoucherV2(state),
    isAuthed: isAuthed(state),
    vouchers: getVouchers(state)
  };
}

export default connect(mapStateToProps)(Layout);
